import { useGetMediaView } from '@cobliteam/hooks/src/useCamera/useCameraMedia';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import { Dialog } from '@cobliteam/ui/components';
import Alert from '@cobliteam/ui/components/Alert';
import type React from 'react';
import { useEffect } from 'react';
import MediaDialogBody from './components/DialogMediaBody/DialogMediaBody';
import MediaDialogFooter from './components/DialogMediaFooter/DialogMediaFooter';
import MediaDialogHeader from './components/DialogMediaHeader/DialogMediaHeader';
import DialogMediaInfo from './components/DialogMediaInfo/DialogMediaInfo';

export interface DialogMediaProps {
  mediaId?: string;
  origin?: 'Triggers' | 'Tracking' | 'Safety Report' | 'Coaching';
  redirectButton?: React.ReactNode;
  actionButton?: React.ReactNode;
  closeButton?: React.ReactNode;
  onClose: () => void;
}

const showDriverInfoMap = new Map<string, boolean>([
  ['Triggers', true],
  ['Tracking', true],
  ['Safety Report', true],
  ['Coaching', false],
]);

const DialogMedia = ({ mediaId, onClose, redirectButton, closeButton, actionButton, origin }: DialogMediaProps) => {
  const { videoEnhancedFeatures } = useFeatureFlags();
  const { data: mediaView, isError, isFetched } = useGetMediaView(mediaId, videoEnhancedFeatures);

  const mediaUrl = mediaView?.mediaUrl;
  const showDriver = showDriverInfoMap.get(origin ?? '') ?? false;

  useEffect(() => {
    if (isError || (isFetched && !mediaUrl)) {
      Alert.error('Erro ao obter dados do vídeo.');
      onClose();
    }
  }, [mediaUrl, isError, isFetched, onClose]);

  return (
    <Dialog open={!!mediaId} onOpenChange={onClose}>
      <Dialog.Content size='md'>
        <Dialog.Title className='sr-only' />
        <Dialog.Description className='sr-only' />
        <Dialog.Header>
          <MediaDialogHeader mediaId={mediaId} />
          <Dialog.Close onClick={onClose} />
        </Dialog.Header>
        <Dialog.Body>
          <DialogMediaInfo showDriver={showDriver} mediaId={mediaId} />
          <MediaDialogBody mediaView={mediaView} />
        </Dialog.Body>

        <Dialog.Footer>
          <MediaDialogFooter redirectButton={redirectButton} actionButton={actionButton} closeButton={closeButton} />
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
};

export default DialogMedia;
